var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "105.84 128.07 388.32 343.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.61,338.07a18.69,18.69,0,0,1-18.67,18.66H313a9.25,9.25,0,0,0-5.49,1.8l-117,85.8V366a9.28,9.28,0,0,0-9.27-9.28H143.06a18.69,18.69,0,0,1-18.67-18.66V165.29a18.69,18.69,0,0,1,18.67-18.66H456.94a18.69,18.69,0,0,1,18.67,18.66Zm-18.67-210H143.06a37.25,37.25,0,0,0-37.22,37.21V338.07a37.26,37.26,0,0,0,37.22,37.22h29v87.36a9.28,9.28,0,0,0,14.76,7.48l129.27-94.84H456.94a37.26,37.26,0,0,0,37.22-37.22V165.29a37.25,37.25,0,0,0-37.22-37.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.42,227.94a23.75,23.75,0,1,0,23.74,23.74,23.74,23.74,0,0,0-23.74-23.74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,227.94a23.75,23.75,0,1,0,23.75,23.74A23.74,23.74,0,0,0,300,227.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.58,227.94a23.75,23.75,0,1,0,23.75,23.74,23.74,23.74,0,0,0-23.75-23.74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactService);
export default __webpack_public_path__ + "static/media/contact-service.153a21a83b12176d33ee5c240b2dd4dc.svg";
export { ForwardRef as ReactComponent };